import { useCallback } from "react";
import { PageScreenShotProcessor } from "../service/ScreenShot/PageScreenShotProcessor";
import { ScreenShotService } from "../service/ScreenShot/ScreenShotService";
import { useSelector } from "react-redux";
import { RootState } from "../store";
import { pageService } from "../service/Page/usePageService";

export const useScreenShot = (screenShotService: ScreenShotService, apolloClient: any) => {
    const previewState = useSelector((state: RootState) => state.appStorage.preview);
    const makePageScreenshot = useCallback(() => {
        const pageData = pageService.getPage();
        if(!pageData?.id && !previewState) return;
    
        screenShotService.runScreenShot(
            new PageScreenShotProcessor(pageData?.id, apolloClient, pageData?.folder?.id)
        );
    }, [screenShotService, apolloClient, previewState]);

    return { makePageScreenshot }
}
